import { TableHeaderProps } from "./Table.interface"

// Define the TableHeader component
const TableHeader = <T, K extends keyof T>({ columns }: TableHeaderProps<T, K>): JSX.Element => {
    const header = columns.map((column: any, index: number) => {
        return (
            <th key={`head-${index}`}>
                {column.label}
            </th>
        );
    });
    return <thead>
        <tr>
            <th>Sr. No.</th>
            {header}
            <th className="text-center">Action</th>
        </tr>
    </thead>;
};

export default TableHeader;